import { render } from "./SwiperPaginationComponent.vue?vue&type=template&id=5bf6eb3b&ts=true"
import script from "./SwiperPaginationComponent.vue?vue&type=script&lang=ts"
export * from "./SwiperPaginationComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__